interface RankItem {
  rank: number;
  title: string;
  meta: string;
  desc: string;
  imageUrl: string;
  imageAlt: string;
}

const rankingItems: RankItem[] = [
  {
    rank: 1,
    title: '《流浪地球3》',
    meta: '科幻 · 2024 · 9.2分',
    desc: '人类命运共同体史诗终章，视觉奇观与情感深度全面升级',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20style%20with%20massive%20space%20station%20and%20earth%20in%20background%2C%20dramatic%20warm%20orange%20and%20deep%20blue%20lighting%2C%20heroic%20silhouettes%2C%20cinematic%20composition%2C%20blockbuster%20movie%20art%2C%20professional%20poster%20design%20with%20Chinese%20aesthetic&width=400&height=560&seq=rank-1-wuma&orientation=portrait',
    imageAlt: '流浪地球3电影海报',
  },
  {
    rank: 2,
    title: '《封神第二部》',
    meta: '奇幻 · 2025 · 8.8分',
    desc: '神话史诗全新篇章，神仙斗法场面恢宏，东方奇幻巅峰之作',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20mystical%20creatures%2C%20golden%20and%20crimson%20color%20scheme%2C%20epic%20battle%20scene%2C%20traditional%20Chinese%20art%20influence%2C%20dramatic%20lighting%2C%20cinematic%20fantasy%20illustration&width=400&height=560&seq=rank-2-wuma&orientation=portrait',
    imageAlt: '封神第二部电影海报',
  },
  {
    rank: 3,
    title: '《热辣滚烫》',
    meta: '喜剧 · 2024 · 8.5分',
    desc: '温暖治愈的都市喜剧，笑中带泪的人生蜕变故事，年度口碑黑马',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20and%20inspiring%20comedy-drama%20movie%20poster%20with%20soft%20golden%20lighting%2C%20urban%20cityscape%20at%20sunset%2C%20hopeful%20and%20uplifting%20mood%2C%20minimalist%20poster%20design%2C%20warm%20color%20palette%2C%20professional%20movie%20art&width=400&height=560&seq=rank-3-wuma&orientation=portrait',
    imageAlt: '热辣滚烫电影海报',
  },
  {
    rank: 4,
    title: '《飞驰人生2》',
    meta: '喜剧 · 2024 · 8.3分',
    desc: '赛道上的热血与欢笑，速度与激情的完美融合，燃到飞起',
    imageUrl: 'https://readdy.ai/api/search-image?query=Racing%20movie%20poster%20with%20fast%20sports%20cars%20on%20a%20racetrack%2C%20dramatic%20motion%20blur%20effect%2C%20warm%20sunset%20sky%2C%20action-packed%20composition%2C%20adrenaline-filled%20atmosphere%2C%20professional%20movie%20poster%20design&width=400&height=560&seq=rank-4-wuma&orientation=portrait',
    imageAlt: '飞驰人生2电影海报',
  },
  {
    rank: 5,
    title: '《第二十条》',
    meta: '剧情 · 2024 · 8.7分',
    desc: '现实主义力作，聚焦社会热点话题，演技炸裂引发深度思考',
    imageUrl: 'https://readdy.ai/api/search-image?query=Serious%20legal%20drama%20movie%20poster%20with%20courtroom%20setting%2C%20solemn%20atmosphere%2C%20warm%20wood%20tones%20and%20soft%20lighting%2C%20realistic%20style%2C%20professional%20Chinese%20film%20poster%20design%2C%20thoughtful%20and%20grounded%20aesthetic&width=400&height=560&seq=rank-5-wuma&orientation=portrait',
    imageAlt: '第二十条电影海报',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              热播榜单
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              根据播放量与用户评分实时更新，发现当下最受欢迎的热门电影
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300"
              >
                <div className="relative h-64 md:h-72 overflow-hidden bg-background-200">
                  <img
                    src={item.imageUrl}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-white text-sm font-bold">
                      {item.rank}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-2">{item.meta}</p>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}